module.exports = {"engravedIdLabel":"OV-chipkaartnûmer","checkEligibilityButton":"Kontrolearje","productConfigurationLabel":"Kies it te bestellen produkt","configurationForm":{"submit":"Kies produkt"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/fy/special-sale.json
// module id = tGSO
// module chunks = 1